import { Observable } from "rxjs";

import { Provider } from "@angular/core";
import { UseCase } from "../../../../core/use-case";
import { Practice } from "../../../models/practice.model";
import { HrRepository } from "../../../repositories/hr.repository";

export class GetAllPracticesUseCase implements UseCase<void, Practice[]> {
  constructor(private repo: HrRepository) {}
  execute(param: void): Observable<Practice[]> {
    return this.repo.getAllPractices();
  }
}

const getAllPracticesUseCaseFactory = (repo: HrRepository) =>
  new GetAllPracticesUseCase(repo);

export const getAllPracticesUseCaseProvider: Provider = {
  provide: GetAllPracticesUseCase,
  useFactory: getAllPracticesUseCaseFactory,
  deps: [HrRepository],
};
